import EditIcon from "@mui/icons-material/Edit";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import React, { Component } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { ValidatorForm } from "react-material-ui-form-validator";
import "react-tabs/style/react-tabs.css";
import FetchServerData from "../../../provider/FetchServerData";
import {
  GetCrmIntegration_Url,
  UpdateCrmIntegration_Url,
  neonCrmIntegration_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import store from "../../../redux/store";
import CancelIconButton from "../buttons/CancelIconButton";
import SaveButton from "../buttons/SaveButton";
import PtsAlert from "../ptsAlert/PtsAlert";
import { styled } from "@mui/material/styles";
import { Switch } from "@material-ui/core";
import NeonCrmLogo from "../../../assets/img/Neon-CRM-Logo.png";
import BlackbaudLogo from "../../../assets/img/blackbaud_Logo.jpg";
import CventLogo from "../../../assets/img/cvent_Logo.jpeg";
import DPTextLogo from "../../../assets/img/dptextLogo.png";
import "./CrmIntegration.css";
import CrmIntegrationAction from "../../../redux/crmIntegration/CrmIntegrationAction";
import pdfFile from "../../../assets/importTemplate/GivBee_Cvent_Setup.pdf";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import EditIconButton from "../buttons/EditIconButton";
import PledgePaymentIntegration from "./PledgePaymentIntegration";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";
// import DonarPaymentConfirmation from "./DonarPaymentConfirmation";
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#b3b3b3" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
class CrmIntegration extends Component {
  header = store.getState().header.header;
  crmIntegrationList = store.getState().staticData.crmIntegrationList;
  pledgePaymentIntegrationList =
    store.getState().staticData.pledgePaymentIntegrationList;
  profile = store.getState().appUserData.appUserData.appuser?.profile;
  accountSettings = store.getState().accountSetting?.accountSetting;

  constructor(props) {
    super(props);
    let action = props.action;
    if (!action && props.state) {
      action = props.state.action;
    }
    if (
      action &&
      Utils.equalsIgnoreCase(
        action,
        "view" || Utils.equalsIgnoreCase(action, "edit")
      )
    ) {
      this.getCrmIntegrationDetails();
    }
    this.state = {
      action: action,
      neonOrgApiKeyShow: false,
      blackBaudRefreshShow: false,
      neonOrgId: "",
      neonOrgApiKey: "",
      blackBaudClientId: "",
      blackBaudClientSecret: "",
      crmIntegration: null,
      neonSettingsId: "",
      blackBaudId: "",
      cEventAccessToken: "",
      cEventRefreshToken: "",
      cEventId: "",
      donerPerfectClientId: "",
      donerPerfectApiKey: "",
      donarPaymentConfirmationText:
        "Your payment has been securely processed. Thank you.",
      webhookUrl: "",
      paypalId: "",
      paypalPaymentId: "",
      paypalPayment: null,
      blackbaudPayment: null,
      CEventApiKeyShow: false,
      donerPerfectApiKeyShow: false,
      openBlackbaud: false,
      isBlackbaudConnected: false,
      isDonarPaymentConfirmationText: false,
      getUpdatePermission: false,
      open: false,
      anchorEl: null,
      isPaypalOpen: false,
      alertVisible: false,
      generateWebhookUrl: false,
      isOptinRequired: false,
      render: false,
    };
  }

  getCrmIntegrationDetails() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(GetCrmIntegration_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let crmIntegrationDetails = output.data;
          let accountSetting = output.data.accountSetting
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getUpdatePermission = getPermission[3];

          if (crmIntegrationDetails?.neonSettings !== null) {
            this.setState({
              neonOrgApiKeyShow: true,
              blackBaudRefreshShow: false,
              CEventApiKeyShow: false,
              donerPerfectApiKeyShow: false,
            });
          } else if (crmIntegrationDetails?.blackbaudSettings !== null) {
            this.setState({
              neonOrgApiKeyShow: false,
              blackBaudRefreshShow: true,
              CEventApiKeyShow: false,
              donerPerfectApiKeyShow: false,
            });
          } else if (crmIntegrationDetails?.cventSettings !== null) {
            this.setState({
              neonOrgApiKeyShow: false,
              blackBaudRefreshShow: false,
              CEventApiKeyShow: true,
              donerPerfectApiKeyShow: false,
            });
          } else if (crmIntegrationDetails?.dpTextSettings !== null) {
            this.setState({
              neonOrgApiKeyShow: false,
              blackBaudRefreshShow: false,
              CEventApiKeyShow: false,
              donerPerfectApiKeyShow: true,
            });
          }
          store.dispatch(
            CrmIntegrationAction.setCrmIntegration(
              crmIntegrationDetails?.crmIntegration?.name
            )
          );
          store.dispatch(AccountSettingDataAction.setAccountSettingData({ accountSetting }));
          this.setState({
            render: true,
            generateWebhookUrl: false,
            // action:
            //   crmIntegrationDetails?.crmIntegration?.name !== "None"
            //     ? "view"
            //     : "edit",
            action: "view",
            pageId: "view",
            neonOrgId: crmIntegrationDetails?.neonSettings?.orgId,
            neonOrgApiKey: crmIntegrationDetails?.neonSettings?.orgApikey,
            neonSettingsId: crmIntegrationDetails?.neonSettings?.id,
            blackBaudClientId:
              crmIntegrationDetails?.blackbaudSettings?.clientid,
            blackBaudClientSecret:
              crmIntegrationDetails?.dpTextSettings?.clientsecret,
            blackBaudSubscriptionkey:
              crmIntegrationDetails?.blackbaudSettings?.subscriptionkey,
            crmIntegration: crmIntegrationDetails?.crmIntegration,
            isBlackBaudConnected:
              crmIntegrationDetails?.blackbaudSettings?.isConnected,
            blackBaudId: crmIntegrationDetails?.blackbaudSettings?.id,
            cEventAccessToken:
              crmIntegrationDetails?.cventSettings?.refreshtoken,
            cEventRefreshToken:
              crmIntegrationDetails?.cventSettings?.accesstoken,
            webhookUrl: crmIntegrationDetails?.cventSettings?.webhookUrl,
            isOptinRequired: crmIntegrationDetails?.cventSettings?.isOptinRequired,
            cEventId: crmIntegrationDetails?.cventSettings?.id,
            donerPerfectId: crmIntegrationDetails?.dpTextSettings?.id,
            donerPerfectApiKey: crmIntegrationDetails?.dpTextSettings?.apikey,
            donerPerfectClientId:
              crmIntegrationDetails?.dpTextSettings?.clientid,
            paypalPayment: crmIntegrationDetails?.paypalPayment,
            paypalId: crmIntegrationDetails?.paypalPayment?.paypalid,
            paypalPaymentId: crmIntegrationDetails?.paypalPayment?.id,
            blackbaudPayment: crmIntegrationDetails?.blackbaudPayment,
            getUpdatePermission: getUpdatePermission,
            pledgePaymentIntegration:
              crmIntegrationDetails.pledgePaymentIntegration,
            pledgePaypalSettings: crmIntegrationDetails.pledgePaypalSettings,
            pledgeBlackbaudSettings:
              crmIntegrationDetails.pledgeBlackbaudSettings,
            donarPaymentConfirmationText:
              crmIntegrationDetails.donarPaymentConfirmationText,
            isDonarPaymentConfirmationText:
              crmIntegrationDetails.isDonarPaymentConfirmationText !== null
                ? crmIntegrationDetails.isDonarPaymentConfirmationText
                : false,
          });
        } else {
        }
      }
    );
  }

  handleCrmIntegrationChange(selectedType) {
    this.state.crmIntegration = selectedType;
    if (undefined === this.state.onChange) {
      this.setState({
        neonOrgApiKeyShow: false,
        blackBaudRefreshShow: false,
      });
    }
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
    if (Utils.equalsIgnoreCase(selectedType?.name, "NeonCRM")) {
      this.setState({
        action: "edit",
        crmIntegration: selectedType,
        neonOrgApiKeyShow: true,
        blackBaudRefreshShow: false,
        CEventApiKeyShow: false,
        donerPerfectApiKeyShow: false,
        blackBaudClientId: "",
        blackBaudClientSecret: "",
        blackBaudSubscriptionkey: "",
        blackBaudId: "",
        cEventAccessToken: "",
        cEventRefreshToken: "",
        cEventId: "",
        donerPerfectClientId: "",
        donerPerfectApiKey: "",
      });
    } else if (Utils.equalsIgnoreCase(selectedType?.name, "BlackBaudCRM")) {
      this.setState({
        action: "edit",
        crmIntegration: selectedType,
        neonOrgApiKeyShow: false,
        blackBaudRefreshShow: true,
        CEventApiKeyShow: false,
        donerPerfectApiKeyShow: false,
        neonOrgApiKey: "",
        neonOrgId: "",
        neonSettingsId: "",
        cEventAccessToken: "",
        cEventRefreshToken: "",
        cEventId: "",
        donerPerfectClientId: "",
        donerPerfectApiKey: "",
      });
    } else if (Utils.equalsIgnoreCase(selectedType?.name, "Cvent")) {
      this.generateWebhookUrl()
      this.setState({
        action: "edit",
        crmIntegration: selectedType,
        neonOrgApiKeyShow: false,
        blackBaudRefreshShow: false,
        CEventApiKeyShow: true,
        donerPerfectApiKeyShow: false,
        blackBaudClientId: "",
        blackBaudClientSecret: "",
        blackBaudSubscriptionkey: "",
        neonOrgApiKey: "",
        neonOrgId: "",
        blackBaudId: "",
        neonSettingsId: "",
        donerPerfectClientId: "",
        donerPerfectApiKey: "",
      });
    } else if (Utils.equalsIgnoreCase(selectedType?.name, "DPText")) {
      this.setState({
        action: "edit",
        crmIntegration: selectedType,
        neonOrgApiKeyShow: false,
        blackBaudRefreshShow: false,
        CEventApiKeyShow: false,
        donerPerfectApiKeyShow: true,
        blackBaudClientId: "",
        blackBaudClientSecret: "",
        blackBaudSubscriptionkey: "",
        neonOrgApiKey: "",
        neonOrgId: "",
        blackBaudId: "",
        neonSettingsId: "",
      });
    } else if (Utils.equalsIgnoreCase(selectedType?.name, "None")) {
      this.setState({
        action: "edit",
        crmIntegration: selectedType,
        neonOrgApiKeyShow: false,
        blackBaudRefreshShow: false,
        CEventApiKeyShow: false,
        donerPerfectApiKeyShow: false,
        blackBaudClientId: "",
        blackBaudClientSecret: "",
        blackBaudSubscriptionkey: "",
        neonOrgApiKey: "",
        neonOrgId: "",
        blackBaudId: "",
        neonSettingsId: "",
        cEventAccessToken: "",
        cEventRefreshToken: "",
        cEventId: "",
        donerPerfectClientId: "",
        donerPerfectApiKey: "",
      });
    }
  }

  handleNeonOrgApiKeyChange(e) {
    this.setState({ neonOrgApiKey: e.target.value });
  }
  handleNenOrgIdChange(e) {
    this.setState({ neonOrgId: e.target.value });
  }
  handleBlackBaudClientIdChange(e) {
    this.setState({ blackBaudClientId: e.target.value });
  }
  handleBlackBaudClientSecretChange(e) {
    this.setState({ blackBaudClientSecret: e.target.value });
  }
  handleBlackBaudSubscriptionkeyChange(e) {
    this.setState({ blackBaudSubscriptionkey: e.target.value });
  }

  handleCEventAccessTokenChange(e) {
    this.setState({ cEventAccessToken: e.target.value });
  }

  handleCEventRefreshTokenChange(e) {
    this.setState({ cEventRefreshToken: e.target.value });
  }
  handleWebhookUrlChange(e) {
    this.setState({ webhookUrl: e.target.value });
  }

  handleDPClientIdChange(e) {
    this.setState({ donerPerfectClientId: e.target.value });
  }
  handleDPApiKeyChange(e) {
    this.setState({ donerPerfectApiKey: e.target.value });
  }
  editCrmIntegrationDetails(crmIntegration) {
    if (crmIntegration?.name === "None") {
      this.setState({
        action: "edit",
        crmIntegration: crmIntegration,
        neonOrgApiKeyShow: false,
        blackBaudRefreshShow: false,
        CEventApiKeyShow: false,
        blackBaudClientId: "",
        blackBaudClientSecret: "",
        blackBaudSubscriptionkey: "",
        neonOrgApiKey: "",
        neonOrgId: "",
        blackBaudId: "",
        neonSettingsId: "",
        cEventAccessToken: "",
        cEventRefreshToken: "",
        cEventId: "",
      });
    } else {
      this.setState({
        action: "edit",
        crmIntegration: crmIntegration,
      });
    }
  }

  onClickCancel(e) {
    // this.setState({
    //   render: true,
    //   action: "view",
    // });
    this.getCrmIntegrationDetails();
  }

  updateCrmIntegrationDetailsInBackend() {
    const postObject = {
      header: this.header,
      crmIntegration: this.state.crmIntegration,
      neonSettings: {
        orgId: this.state.neonOrgId,
        orgApikey: this.state.neonOrgApiKey,
        id: this.state.neonSettingsId,
      },
      cventSettings: {
        webhookUrl: this.state.webhookUrl,
        // isOptinRequired: this.state.isOptinRequired,
        id: this.state.cEventId,
      },
      dpTextSettings: {
        apikey: this.state.donerPerfectApiKey,
        clientid: this.state.donerPerfectClientId,
        id: this.state.donerPerfectId,
      },
    };
    FetchServerData.callPostService(UpdateCrmIntegration_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          // let organizationData = output.data;
          this.setState({
            render: true,
            action: "view",
          });
          this.getCrmIntegrationDetails();
        } else {
        }
      }
    );
  }

  neonCrmIntegrationCheckConnection() {
    const postObject = {
      header: this.header,
      orgId: this.state.neonOrgId,
      apiKey: this.state.neonOrgApiKey,
    };

    FetchServerData.callPostService(neonCrmIntegration_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
        } else {
        }
      }
    );
  }

  blackBaudIntegration() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(
      "/blackbaudcrmms/getAuthURL",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        const popup = window.open(
          output.data.authUrl,
          "login",
          "width=600,height=500,screenX=500,screenY=80"
        );

        const timer = setInterval(() => {
          if (popup.closed) {
            clearInterval(timer);
            this.getCrmIntegrationDetails();
          }
        }, 1000);
      } else {
      }
    });
  }

  generateWebhookUrl() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(
      "/cventcrmms/getWebhookURL",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let webhookDetails = output.data;
        this.setState({
          webhookUrl: webhookDetails.webhookUrl,
          generateWebhookUrl: true
        });
      } else {
      }
    });
  }
  handleOpen() {
    this.setState({ openBlackbaud: true });
  }

  handleClose() {
    this.setState({ openBlackbaud: false });
  }

  handlePaypalOpen() {
    this.setState({ isPaypalOpen: true, pageId: "addPaypal" });
  }

  handlePaypalClose() {
    this.setState({ isPaypalOpen: false });
  }

  handlePaypalIDChange(e) {
    this.setState({
      paypalId: e.target.value,
    });
  }

  handleEditPaypalOpen() {
    this.setState({
      isPaypalOpen: true,
      pageId: "editPaypal",
      paypalId: this.state.paypalId,
    });
  }

  helpContentsDialogBox() {
    return (
      <Dialog
        open={this.state.openBlackbaud}
        onClose={this.handleClose.bind(this)}
        maxWidth="xl"
        className="QRCodeDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>
            How to connect GivBee to RE NXT
          </span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent>
          <div
            className="row d-flex"
            style={{
              width: "100%",
              color: "#000",
              fontSize: "small",
              padding: "0.5em",
            }}
          >
            <p>
              <span className="fw-bold fs-6">
                Connect your Blackbaud account to the GivBee application
              </span>
              <ol className="m-2">
                <li className="mb-2">
                  Login to your Blackbaud account via this link:
                  <a
                    className="anchortag ms-1"
                    target="blank"
                    href="https://app.blackbaud.com/marketplace/manage"
                  >
                    https://app.blackbaud.com/marketplace/manage
                  </a>
                </li>
                <li className="mb-2">
                  Click the "+ Connect app" button and search for the GivBee app with this ID: 80a6d929-5683-43aa-959b-a6993aa4ef96
                </li>
                <li>Click "Connect".</li>
                <li>Close this pop up and click “Connect”.</li>
              </ol>
            </p>
          </div>
        </DialogContent>
        <DialogActions
          style={{
            // marginTop: "1em",
            padding: "1em",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <Button
            type="button"
            variant="contained"
            size="small"
            style={{
              background: "#224f77",
              color: "#fff",
            }}
            onClick={this.handleClose.bind(this)}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  createPaypalToBackend() {
    const postObject = {
      header: this.header,
      paymentPaypal: {
        paypalid: this.state.paypalId,
      },
    };
    FetchServerData.callPostService("/paymentPaypalms/create", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getCrmIntegrationDetails();
        } else {
        }
      }
    );
  }

  updatePaypalToBackend() {
    const postObject = {
      header: this.header,
      paymentPaypal: {
        paypalid: this.state.paypalId,
        id: this.state.paypalPaymentId,
      },
    };
    FetchServerData.callPostService("/paymentPaypalms/update", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let paymentPaypal = output.data.paymentPaypal;
          this.setState({
            isPaypalOpen: false,
            paypalPayment: paymentPaypal,
            paypalId: paymentPaypal.paypalid,
            paypalPaymentId: paymentPaypal.id,
          });
        } else {
        }
      }
    );
  }

  handlePledgePaymentIntegrationChange(selectedValue) {
    this.setState({
      pledgePaymentIntegration: selectedValue,
    });
  }
  editPaymentIntegrationDetails() {
    this.setState({
      render: true,
      action: "editPaymentUntegration",
    });
  }

  handleCopy = (copiedIndex) => {
    if (copiedIndex !== null) {
      this.setState({
        alertVisible: false,
        copiedIndex: copiedIndex,
      });
    } else {
      this.setState({
        alertVisible: true,
        copiedIndex: copiedIndex,
      });
    }

    setTimeout(() => {
      this.setState({ alertVisible: false, copiedIndex: null });
    }, 1000);
  };

  maskApiKey(apiKey) {
    if (!apiKey) return "";
    const visibleChars = 5; // show last 5 characters
    const maskedLength = apiKey.length - visibleChars;
    if (maskedLength <= 0) return apiKey; // if key is too short, show as-is
    return "*".repeat(maskedLength) + apiKey.slice(-visibleChars);
  }
  maskDonerPerfectApiKey(apiKey) {
    if (!apiKey) return "";
    return apiKey.slice(-5);
  }


  handleIsOptinRequiredChange(e) {
    this.setState({ isOptinRequired: !this.state.isOptinRequired });
  }

  onCopy = (e) => {
    if (navigator?.clipboard) {
      navigator?.clipboard?.writeText(this.state.webhookUrl);
    }
    this.setState({ alertVisible: true });
    setTimeout(() => {
      this.setState({ alertVisible: false, copiedIndex: null });
    }, 1000);
  };

  render() {
    if (this.state.action === "view") {
      return this.viewCrmIntegration();
    } else if (this.state.action === "edit") {
      return this.editCrmIntegration();
    } else {
      return this.editPaymentIntegration();
    }
  }
  viewCrmIntegration() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          {/* <div className="row" style={{ width: "100%", marginTop: "1em" }}> */}
          {/* <div className="col-md-6"></div>
            <div className="col-md-6">
              {this.state.getUpdatePermission && (
                <Button
                  type={this.state.type ? this.state.type : ""}
                  variant="contained"
                  size="small"
                  style={{
                    background: "#d3d8de",
                    color: "#353538",
                    textTransform: "capitalize",
                    float: "right",
                  }}
                  startIcon={<EditIcon />}
                  onClick={this.editCrmIntegrationDetails.bind(
                    this,
                    this.state.crmIntegration
                  )}
                >
                  Edit
                </Button>
              )}
            </div> */}
          {/* </div> */}
          <div className="row">
            <div className="col-md-12">
              <div
                className="card"
                id="giveBeeCardTopBoxShadowremove"
                style={{
                  minHeight: "260px",
                  borderRadius: "0rem 0.5rem 0.5rem 0.5rem",
                }}
              >
                <div
                  className="card-header d-flex align-items-center justify-content-between p-2 pt-0"
                  id="assetCardHeader"
                >
                  <div className="col-md-6 align-self-center">
                    <h6 className="mb-0" id="headerLabel">
                      CRM Integration
                    </h6>
                  </div>
                  <div
                    className="col-md-6 text-end"
                    style={{
                      // borderRight: "1px solid #eceaea",
                      // background: "#ececec",
                      color: "#000",
                      fontWeight: "bold",
                      padding: "0.5em",
                      textAlign: "right",
                    }}
                  >
                    {this.state.getUpdatePermission && (
                      <EditIconButton
                        onClick={this.editCrmIntegrationDetails.bind(
                          this,
                          this.state.crmIntegration
                        )}
                      />
                    )}
                  </div>
                </div>
                <div className="card-body">
                  <div className="row d-flex">
                    <div className="col-md-3 pt-2">
                      <div className="row">
                        <div className="col-md-12 text-center">
                          {this.state.crmIntegration?.name !== "None" && (
                            <>
                              {this.state.neonOrgApiKeyShow && (
                                <img
                                  src={NeonCrmLogo}
                                  className="neonCrmLogo"
                                />
                              )}
                              {this.state.blackBaudRefreshShow && (
                                <img
                                  src={BlackbaudLogo}
                                  className="blackbaudLogo"
                                />
                              )}
                              {this.state.CEventApiKeyShow && (
                                <img src={CventLogo} className="neonCrmLogo" />
                              )}
                              {this.state.donerPerfectApiKeyShow && (
                                <img src={DPTextLogo} className="neonCrmLogo" />
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row" style={{ minHeight: "37.56px" }}>
                            <label
                              className="col-sm-3 col-form-label fw-bold align-self-center"
                              htmlFor="basic-default-supplierType"
                              id="assetFormLabel"
                            >
                              CRM Integration
                            </label>
                            <div className="col-sm-9" id="givbeeText">
                              <span className="me-4">
                                {this.state.crmIntegration?.description}
                              </span>
                              {this.state.blackBaudRefreshShow && (
                                // <IconButton onClick={(e) => this.handleOpen(e)}>
                                //   <i
                                //     class="fa fa-question-circle"
                                //     aria-hidden="true"
                                //   ></i>
                                // </IconButton>
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.handleOpen();
                                  }}
                                  className="anchortag"
                                >
                                  <u>How to connect</u>
                                </a>
                              )}
                              {/* <Button
                                className="givbeeButton"
                                style={{
                                  color: "white",
                                  width: "80px",
                                  height: "28px",
                                  fontWeight: "600",
                                  fontSize: "x-larger",
                                  textTransform: "capitalize",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => this.handleOpen(e)}
                              >
                                Help
                              </Button> */}
                            </div>
                          </div>
                        </div>
                        {this.state.neonOrgApiKeyShow && (
                          <>
                            <div className="col-md-12">
                              {this.state.neonOrgId && (
                                <div className="row p-1">
                                  <label
                                    className="col-sm-3 col-form-label fw-bold"
                                    htmlFor="basic-default-name"
                                    id="assetFormLabel"
                                  >
                                    Neon Organization ID
                                  </label>
                                  <div className="col-md-9" id="givbeeText">
                                    <span>{this.state.neonOrgId}</span>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="col-md-12">
                              {this.state.neonOrgApiKey && (
                                <div className="row p-1">
                                  <label
                                    className="col-sm-3 col-form-label fw-bold"
                                    htmlFor="basic-default-name"
                                    id="assetFormLabel"
                                  >
                                    Neon Organization API Key
                                  </label>
                                  <div className="col-sm-9" id="givbeeText">
                                    <span>{this.state.neonOrgApiKey}</span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                        {this.state.blackBaudRefreshShow && (
                          <>
                            <div className="col-md-12">
                              {this.state.isBlackBaudConnected && (
                                <div className="row p-1">
                                  <label
                                    className="col-sm-3 col-form-label fw-bold"
                                    htmlFor="basic-default-name"
                                    id="assetFormLabel"
                                  >
                                    Status
                                  </label>
                                  <div className="col-md-9" id="givbeeText">
                                    <span>Connected</span>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="col-md-12">
                              {this.state.crmIntegration?.name !== "None" && (
                                <div className="row p-1">
                                  <div
                                    className="col-sm-3 "
                                    id="givbeeText"
                                  ></div>
                                  <div
                                    className="col-sm-9 mt-4"
                                    id="givbeeText"
                                  >
                                    <div className="row ms-1 align-items-end">
                                      {/* <Button
                                        className="givbeeButton"
                                        style={{
                                          color: "white",
                                          width: "80px",
                                          height: "28px",
                                          fontWeight: "600",
                                          fontSize: "x-larger",
                                          textTransform: "capitalize",
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) => this.handleOpen(e)}
                                      >
                                        Help
                                      </Button>
                                      &nbsp; &nbsp; */}
                                      {!this.state.isBlackBaudConnected && (
                                        <Button
                                          type="button"
                                          className="givbeeButton"
                                          variant="contained"
                                          style={{
                                            color: "white",
                                            width: "80px",
                                            height: "28px",
                                            fontWeight: "600",
                                            fontSize: "x-larger",
                                            textTransform: "capitalize",
                                            cursor: "pointer",
                                          }}
                                          onClick={(e) =>
                                            this.blackBaudIntegration()
                                          }
                                        >
                                          Connect
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                        {this.state.CEventApiKeyShow && (
                          <>
                            <div className="col-md-12">
                              {this.state.webhookUrl && (
                                <>
                                  <div className="row mt-2">
                                    <label
                                      className="col-sm-3 col-form-label fw-bold align-self-center"
                                      htmlFor="basic-default-name"
                                      id="assetFormLabel"
                                    >
                                      Webhook URL
                                    </label>
                                    <div className="col-md-9" id="givbeeText">
                                      <span className="me-2">
                                        {this.state.webhookUrl}
                                      </span>
                                      {/* <IconButton>
                                        <CopyToClipboard
                                          text={this.state.webhookUrl}
                                          onClick={this.onCopy}
                                        >
                                          <FileCopyIcon
                                            style={{
                                              color: "gray",
                                              fontSize: "20px",
                                            }}
                                            onClick={this.handleCopy.bind(
                                              this,
                                              null
                                            )}
                                          />
                                        </CopyToClipboard>
                                      </IconButton> */}
                                      <span
                                        className="cursor-pointer anchortag pt-2"
                                        style={{ fontSize: "14px" }}
                                        onClick={this.onCopy}
                                      >
                                        <u>copy</u>
                                      </span>
                                      &nbsp;&nbsp;
                                      {this.state.alertVisible && (
                                        <span className="CopyToClipboard">
                                          url copied.
                                        </span>
                                      )}
                                    </div>
                                    <label className="col-sm-3"></label>
                                    <span
                                      className="col-md-9"
                                      id="givbeeText"
                                    // style={{
                                    //   fontSize: "12px",
                                    //   color: "black",
                                    // }}
                                    >
                                      <b style={{ color: "#566a7f" }}>
                                        Note: Add this webhook url to your cvent
                                        account.
                                      </b>
                                    </span>
                                  </div>
                                  {/* <div className="row mt-2">
                                    <label
                                      className="col-sm-3 col-form-label fw-bold align-self-center"
                                      htmlFor="basic-default-name"
                                      id="assetFormLabel"
                                    >
                                      Is Text Message Opt-In Required
                                    </label>
                                    <div className="col-md-9" id="givbeeText">
                                      {this.state.isOptinRequired ? "Yes" : "No"}
                                    </div>
                                  </div> */}
                                  <div className="row p-1 pt-4">
                                    <div className="col-sm-3"></div>
                                    <div className="col-sm-9">
                                      <span
                                        className="anchortag"
                                        onClick={(e) => {
                                          e.preventDefault();

                                          if (!pdfFile) {
                                            alert("PDF file not found.");
                                            return;
                                          }

                                          // Create a temporary link and trigger download
                                          const link =
                                            document.createElement("a");
                                          link.href = pdfFile;
                                          link.download =
                                            "GivBee_Cvent_Setup.pdf";
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);
                                        }}
                                      >
                                        <u>Download setup instructions for Cvent integration</u>
                                      </span>
                                      <Tooltip
                                        arrow
                                        title="Download"
                                        classes={{ popper: "custom-tooltip" }}
                                      >
                                        <DownloadForOfflineIcon
                                          style={{
                                            borderRadius: "25%",
                                            color: "#6A7B8E",
                                            fontSize: "x-large",
                                            width: "30px",
                                            minHeight: "30px",
                                            padding: "3px",
                                            cursor: "pointer"
                                          }}
                                          onClick={(e) => {
                                            e.preventDefault();

                                            if (!pdfFile) {
                                              alert("PDF file not found.");
                                              return;
                                            }

                                            const link =
                                              document.createElement("a");
                                            link.href = pdfFile;
                                            link.download =
                                              "GivBee_Cvent_Setup.pdf";
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                          }}
                                        />
                                      </Tooltip>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </>
                        )}
                        {this.state.donerPerfectApiKeyShow && (
                          <>
                            <div className="col-md-12">
                              {this.state.donerPerfectClientId && (
                                <div className="row ps-0 p-1" style={{ height: "46.72px" }}>
                                  <label
                                    className="col-sm-3 col-form-label fw-bold align-self-center"
                                    htmlFor="basic-default-name"
                                    id="assetFormLabel"
                                  >
                                    DP Client ID
                                  </label>
                                  <div className="col-md-9" id="givbeeText">
                                    <span>
                                      {this.state.donerPerfectClientId}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="col-md-12">
                              {this.state.donerPerfectApiKey && (
                                <div className="row ps-0 p-1" style={{ height: "46.72px" }}>
                                  <label
                                    className="col-sm-3 col-form-label fw-bold align-self-center"
                                    htmlFor="basic-default-name"
                                    id="assetFormLabel"
                                  >
                                    DP API Key <span className="fw-normal" id="givbeeText">(Last 5)</span>
                                  </label>
                                  <div className="col-sm-9" id="givbeeText">
                                    <span>
                                      {this.maskDonerPerfectApiKey(
                                        this.state.donerPerfectApiKey
                                      )}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  {this.state.crmIntegration?.name === "None" && (
                    <div className="row d-flex mt-4">
                      <div className="col-md-3 text-end align-self-center">
                        {/* <h6 style={{ color: "#000" }}>
                          <b>Available CRM Integration</b>
                        </h6> */}
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <label
                            className="col-sm-3 col-form-label fw-bold align-self-center"
                            htmlFor="basic-default-supplierType"
                            id="assetFormLabel"
                          >
                            Available CRM Integrations
                          </label>
                          <div className="col-sm-9 d-flex">
                            {this.crmIntegrationList?.map((value, index) => (
                              <>
                                {value.name === "NeonCRM" && (
                                  <div
                                    className="text-start"
                                    style={{ width: "120px" }}
                                  >
                                    <img
                                      src={NeonCrmLogo}
                                      style={{
                                        width: "80px",
                                        height: "40px",
                                      }}
                                      onClick={this.handleCrmIntegrationChange.bind(
                                        this,
                                        value
                                      )}
                                      className="neonCrmLogo cursor-pointer"
                                    />
                                  </div>
                                )}
                                {value.name === "BlackBaudCRM" && (
                                  <div
                                    className="text-start"
                                    style={{ width: "80px" }}
                                  >
                                    <img
                                      src={BlackbaudLogo}
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                      }}
                                      onClick={this.handleCrmIntegrationChange.bind(
                                        this,
                                        value
                                      )}
                                      className="blackbaudLogo cursor-pointer"
                                    />
                                  </div>
                                )}
                                {value.name === "Cvent" && (
                                  <div
                                    className="text-start"
                                    style={{ width: "120px" }}
                                  >
                                    <img
                                      src={CventLogo}
                                      style={{
                                        width: "80px",
                                        height: "40px",
                                      }}
                                      onClick={this.handleCrmIntegrationChange.bind(
                                        this,
                                        value
                                      )}
                                      className="neonCrmLogo cursor-pointer"
                                    />
                                  </div>
                                )}
                                {value.name === "DPText" && (
                                  <div
                                    className="text-start"
                                    style={{ width: "120px" }}
                                  >
                                    <img
                                      src={DPTextLogo}
                                      style={{
                                        width: "80px",
                                        height: "40px",
                                      }}
                                      onClick={this.handleCrmIntegrationChange.bind(
                                        this,
                                        value
                                      )}
                                      className="neonCrmLogo cursor-pointer"
                                    />
                                  </div>
                                )}
                              </>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {this.helpContentsDialogBox()}
          {this.accountSettings?.enablePaymentIntegration && (
            <PledgePaymentIntegration
              action="view"
              pledgePaymentIntegration={this.state.pledgePaymentIntegration}
              pledgePaypalSettings={this.state.pledgePaypalSettings}
              pledgeBlackbaudSettings={this.state.pledgeBlackbaudSettings}
              isDonarPaymentConfirmationText={
                this.state.isDonarPaymentConfirmationText
              }
              donarPaymentConfirmationText={
                this.state.donarPaymentConfirmationText
              }
            />
          )}
          {/* <DonarPaymentConfirmation
            action="view"
            isDonarPaymentConfirmationText={
              this.state.isDonarPaymentConfirmationText
            }
            donarPaymentConfirmationText={
              this.state.donarPaymentConfirmationText
            }
          /> */}
        </>
      );
    }
  }
  editCrmIntegration() {
    return (
      <>
        <ValidatorForm
          ref="form"
          id="multiStepsForm"
          onSubmit={this.updateCrmIntegrationDetailsInBackend.bind(this)}
        >
          <div id="useCaseDetailsValidation" style={{ padding: "0em 0em" }}>
            <div
              className="card "
              id="giveBeeCardTopBoxShadowremove"
              style={{
                minHeight: "260px",
                borderRadius: "0rem 0.5rem 0.5rem 0.5rem",
              }}
            >
              <div
                className="card-header d-flex align-items-center justify-content-between p-2 pt-0"
                id="assetCardHeader"
              >
                <div className="col-md-6 align-self-center">
                  <h6 className="mb-0" id="headerLabel">
                    CRM Integration
                  </h6>
                </div>
                <div
                  className="col-md-6 text-end"
                  style={{
                    // borderRight: "1px solid #eceaea",
                    // background: "#ececec",
                    color: "#000",
                    fontWeight: "bold",
                    padding: "0.5em",
                    textAlign: "right",
                    height: "42px",
                  }}
                ></div>
              </div>
              <div className="card-body">
                <div className="row d-flex">
                  <div className="col-md-3 pt-2">
                    <div className="row">
                      <div className="col-md-12 text-center">
                        {this.state.neonOrgApiKeyShow && (
                          <img src={NeonCrmLogo} className="neonCrmLogo" />
                        )}
                        {this.state.blackBaudRefreshShow && (
                          <img src={BlackbaudLogo} className="blackbaudLogo" />
                        )}
                        {this.state.CEventApiKeyShow && (
                          <img src={CventLogo} className="neonCrmLogo" />
                        )}
                        {this.state.donerPerfectApiKeyShow && (
                          <img src={DPTextLogo} className="neonCrmLogo" />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8 align-self-baseline">
                    <div className="row">
                      <label
                        htmlFor="exampleFormControlTextarea1"
                        className="col-sm-3 col-form-label fw-bold align-self-center"
                      >
                        CRM Integration
                      </label>
                      <div className="col-sm-6 m-0" id="givbeeText">
                        <Autocomplete
                          id="size-small-outlined"
                          size="small"
                          fullWidth
                          disableClearable
                          ListboxProps={{
                            className: "custom-listbox",
                          }}
                          options={this.crmIntegrationList}
                          value={this.state.crmIntegration}
                          getOptionLabel={(option) => option.description}
                          defaultValue={this.state.crmIntegration}
                          onChange={(event, value) => {
                            this.handleCrmIntegrationChange(value);
                          }}
                          inputprops={{
                            style: {
                              textTransform: "capitalize",
                            },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Please Select"
                              variant="outlined"
                              size="small"
                              className="textField"
                              style={{ background: "#fff" }}
                            />
                          )}
                        />
                      </div>
                      {/* {this.state.CEventApiKeyShow && (
                        <div className="col-sm-3 align-self-end">
                          <Button
                            type="button"
                            variant="contained"
                            disabled={this.state.generateWebhookUrl}
                            style={{
                              background: this.state.generateWebhookUrl ? "#8ea7d0" : "#37517e",
                              color: "white",
                              fontWeight: "600",
                              fontSize: "x-larger",
                              textTransform: "capitalize",
                              cursor: "pointer",
                            }}
                            onClick={(e) => this.generateWebhookUrl()}
                          >
                            Generate Webhook URL
                          </Button>
                        </div>
                      )} */}
                    </div>
                    {this.state.neonOrgApiKeyShow && (
                      <>
                        <div className="row mt-2">
                          <label
                            htmlFor="exampleFormControlTextarea1"
                            className="col-sm-3 col-form-label fw-bold align-self-center"
                          >
                            Neon Organization ID
                          </label>
                          <div className="col-sm-6 m-0" id="givbeeText">
                            <input
                              title=""
                              autoComplete="off"
                              required
                              id="multiStepsCard"
                              className="form-control multi-steps-card"
                              name="multiStepsCard"
                              type="text"
                              aria-describedby="multiStepsCardImg"
                              value={this.state.neonOrgId}
                              onChange={this.handleNenOrgIdChange.bind(this)}
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <label
                            htmlFor="exampleFormControlTextarea1"
                            className="col-sm-3 col-form-label fw-bold align-self-center"
                          >
                            Neon Organization API Key
                          </label>
                          <div className="col-sm-6 m-0" id="givbeeText">
                            <input
                              title=""
                              autoComplete="off"
                              required
                              id="multiStepsCard"
                              className="form-control multi-steps-card"
                              name="multiStepsCard"
                              type="text"
                              aria-describedby="multiStepsCardImg"
                              value={this.state.neonOrgApiKey}
                              onChange={this.handleNeonOrgApiKeyChange.bind(
                                this
                              )}
                            />
                          </div>
                          <div
                            className="col-sm-3"
                            style={{ textAlign: "left", marginTop: "auto" }}
                          >
                            {this.state.neonOrgApiKeyShow && (
                              <Button
                                type="button"
                                variant="contained"
                                style={{
                                  background: "#37517e",
                                  color: "white",
                                  width: "100px",
                                  fontWeight: "600",
                                  fontSize: "x-larger",
                                  textTransform: "capitalize",
                                  cursor: "pointer",
                                }}
                                onClick={(e) =>
                                  this.neonCrmIntegrationCheckConnection()
                                }
                              >
                                Connect
                              </Button>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {this.state.CEventApiKeyShow && (
                      <>
                        {this.state.webhookUrl &&
                          <>
                            <div className="row mt-2">
                              <label
                                className="col-sm-3 col-form-label fw-bold align-self-center"
                                htmlFor="multiStepsCard"
                              >
                                Webhook URL
                              </label>
                              <div className="col-sm-9 m-0 align-self-center" id="givbeeText">
                                <>
                                  <span className="me-2">
                                    {this.state.webhookUrl}
                                  </span>
                                  {/* <IconButton>
                                    <CopyToClipboard
                                      text={this.state.webhookUrl}
                                      onClick={this.onCopy}
                                    >
                                      <FileCopyIcon
                                        style={{
                                          color: "gray",
                                          fontSize: "20px",
                                        }}
                                        onClick={this.handleCopy.bind(
                                          this,
                                          null
                                        )}
                                      />
                                    </CopyToClipboard>
                                  </IconButton> */}

                                  <span
                                    className="cursor-pointer anchortag pt-2"
                                    style={{ fontSize: "14px" }}
                                    onClick={this.onCopy}
                                  >
                                    <u>copy</u>
                                  </span>
                                  &nbsp;&nbsp;
                                  {this.state.alertVisible && (
                                    <span className="CopyToClipboard">
                                      url copied.
                                    </span>
                                  )}
                                </>
                              </div>
                            </div>
                            {/* <div className="row mt-2">
                              <label
                                className="col-sm-3 col-form-label fw-bold align-self-center pe-0"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Is Text Message Opt-In Required
                              </label>
                              <div className="col-md-9" id="givbeeText">
                                <span>
                                  <label class="switch">
                                    <input
                                      type="checkbox"
                                      checked={this.state.isOptinRequired}
                                      value={this.state.isOptinRequired}
                                      onChange={this.handleIsOptinRequiredChange.bind(
                                        this
                                      )}
                                    />
                                    <span class="slider round"></span>
                                  </label>
                                </span>
                              </div>
                            </div> */}
                          </>
                        }
                      </>
                    )}

                    {this.state.donerPerfectApiKeyShow && (
                      <>
                        <div className="row mt-2">
                          <label
                            htmlFor="exampleFormControlTextarea1"
                            className="col-sm-3 col-form-label fw-bold"
                          >
                            DP Client ID
                          </label>
                          <div className="col-sm-6 m-0" id="givbeeText">
                            <input
                              title=""
                              autoComplete="off"
                              required
                              id="multiStepsCard"
                              className="form-control multi-steps-card"
                              name="multiStepsCard"
                              type="text"
                              aria-describedby="multiStepsCardImg"
                              value={this.state.donerPerfectClientId}
                              onChange={this.handleDPClientIdChange.bind(this)}
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <label
                            htmlFor="exampleFormControlTextarea1"
                            className="col-sm-3 col-form-label fw-bold"
                          >
                            DP API Key
                          </label>
                          <div className="col-sm-6 m-0" id="givbeeText">
                            {this.profile?.name?.toLowerCase() === "admin" ? (
                              <input
                                title=""
                                autoComplete="off"
                                required
                                id="multiStepsCard"
                                className="form-control multi-steps-card"
                                name="multiStepsCard"
                                type="text"
                                aria-describedby="multiStepsCardImg"
                                value={this.state.donerPerfectApiKey}
                                onChange={this.handleDPApiKeyChange.bind(this)}
                              />
                            ) : (
                              <input
                                title=""
                                autoComplete="off"
                                required
                                id="multiStepsCard"
                                className="form-control multi-steps-card"
                                name="multiStepsCard"
                                type="text"
                                aria-describedby="multiStepsCardImg"
                                value={this.maskApiKey(
                                  this.state.donerPerfectApiKey
                                )}
                                onChange={this.handleDPApiKeyChange.bind(this)}
                              />
                            )}
                          </div>
                          <div
                            className="col-sm-3"
                            style={{ textAlign: "left", marginTop: "auto" }}
                          >
                            {this.state.neonOrgApiKeyShow && (
                              <Button
                                type="button"
                                variant="contained"
                                style={{
                                  background: "#37517e",
                                  color: "white",
                                  width: "100px",
                                  fontWeight: "600",
                                  fontSize: "x-larger",
                                  textTransform: "capitalize",
                                  cursor: "pointer",
                                }}
                                onClick={(e) =>
                                  this.neonCrmIntegrationCheckConnection()
                                }
                              >
                                Connect
                              </Button>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="row d-flex align-items-center justify-content-between">
                <div className="col-sm-12 text-center">
                  <SaveButton id="saveButton" type="submit">
                    Save
                  </SaveButton>
                  &nbsp;&nbsp;
                  <CancelIconButton onClick={(e) => this.onClickCancel()} />
                </div>
              </div>
            </div>
          </div>
        </ValidatorForm>
        {this.helpContentsDialogBox()}
      </>
    );
  }
  editPaymentIntegration() {
    return (
      <>
        <ValidatorForm
          ref="form"
          id="multiStepsForm"
        // onSubmit={this.updateCrmIntegrationDetailsInBackend.bind(this)}
        >
          <div
            id="useCaseDetailsValidation"
            style={{ padding: "0em 0em", marginTop: "0.5em" }}
          >
            <div className="card " id="giveBeeCard">
              <div className="card-body">
                <div className="row d-flex align-items-center">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-sm-8">
                        {" "}
                        <label
                          htmlFor="exampleFormControlTextarea1"
                          className="form-label"
                        >
                          Payment Integration
                        </label>
                        <Autocomplete
                          id="size-small-outlined"
                          size="small"
                          fullWidth
                          disableClearable
                          ListboxProps={{
                            className: "custom-listbox",
                          }}
                          options={this.pledgePaymentIntegrationList}
                          value={this.state.pledgePaymentIntegration}
                          getOptionLabel={(option) => option.description}
                          defaultValue={this.state.crmIntegration}
                          onChange={(event, value) => {
                            this.handlePledgePaymentIntegrationChange(value);
                          }}
                          inputprops={{
                            style: {
                              textTransform: "capitalize",
                            },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Please Select"
                              variant="outlined"
                              size="small"
                              className="textField"
                              style={{ background: "#fff" }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row d-flex align-items-center justify-content-between">
            <div className="col-sm-12 mt-4 text-center">
              <SaveButton id="saveButton" type="submit">
                Save
              </SaveButton>
              &nbsp;&nbsp;
              <CancelIconButton onClick={(e) => this.onClickCancel()} />
            </div>
          </div>
        </ValidatorForm>
      </>
    );
  }
}

export default CrmIntegration;
